module.exports = __webpack_public_path__ + "img/remark_06.f26fa9fa.svg";